import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { Actions } from 'Flux/Slice/index.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import type { Epic } from 'Flux/index.js'

export const DeleteSamplePoolEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.deleteSamplePoolRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.deleteSamplePool(
        {
          orderId: action.payload.orderId,
          poolId: action.payload.poolId
        },
        state.authentication.user
      ).pipe(
        mergeMap(() =>
          of(
            order.deleteSamplePoolSuccess({
              orderId: action.payload.orderId,
              poolId: action.payload.poolId
            })
          )
        ),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.deleteSamplePoolFailure({ error }))
          })
        ),
        catchError((error: Error) => {
          console.error('Error deleting sample pool', error)
          return of(order.deleteSamplePoolFailure({ error }))
        })
      )
    )
  )